import { TaskCompletion } from "../api/models/task/taskcompletion";

export const filterCompletionsThisWeek = (tasks: TaskCompletion[], now: Date = new Date()): TaskCompletion[] => {
    // Determine start of the week (Monday 00:00)
    const day = now.getDay(); // 0 = Sunday, 1 = Monday, ...
    const diffToMonday = (day + 6) % 7; // convert Sunday=0 to 6
    const startOfWeek = new Date(now);
    startOfWeek.setHours(0, 0, 0, 0); // set to 00:00
    startOfWeek.setDate(now.getDate() - diffToMonday);
    const nextWeek = new Date(startOfWeek);
    nextWeek.setDate(startOfWeek.getDate() + 7);

    return tasks.filter(item => {
        return new Date(item.date) >= startOfWeek && new Date(item.date) < nextWeek;
    });
}